import { Controller } from "@hotwired/stimulus"
require('simplelightbox')

export default class extends Controller {
  static targets = ['element'];

  connect() {
    new SimpleLightbox(this.elementTargets, {
      fadeSpeed: 100,
      animationSlide: false,
      scrollZoom: false,
      focus: false,
      history: false
    });
  }
}
